/**
 * Hardcoded London (FEH13) — typical SE England — design-storm
 * depths in mm by return period × duration. Demo-grade lookup table:
 * production should query the FEH Web Service
 * (https://fehweb.ceh.ac.uk/) per-site; these numbers are a
 * region-averaged stand-in so the user can populate the storm-mode
 * inputs with one click.
 */

export type ReturnYears = 1 | 5 | 10 | 30 | 100;
export type DurationLabel = '60min' | '6hr' | '24hr';

interface StormPresetRow {
  '60min': number; // mm
  '6hr': number; // mm
  '24hr': number; // mm
}

export const FEH13_LONDON_PRESETS: Record<ReturnYears, StormPresetRow> = {
  1: { '60min': 14, '6hr': 22, '24hr': 30 },
  5: { '60min': 22, '6hr': 36, '24hr': 46 },
  10: { '60min': 26, '6hr': 44, '24hr': 56 },
  30: { '60min': 33, '6hr': 58, '24hr': 74 },
  100: { '60min': 42, '6hr': 78, '24hr': 100 },
};

const DURATION_HOURS: Record<DurationLabel, number> = {
  '60min': 1,
  '6hr': 6,
  '24hr': 24,
};

export const RETURN_YEAR_OPTIONS: ReturnYears[] = [1, 5, 10, 30, 100];
export const DURATION_OPTIONS: DurationLabel[] = ['60min', '6hr', '24hr'];

export function lookupStorm(
  returnYears: ReturnYears,
  duration: DurationLabel,
): { depthMm: number; durationH: number } {
  return {
    depthMm: FEH13_LONDON_PRESETS[returnYears][duration],
    durationH: DURATION_HOURS[duration],
  };
}
